import { useContext, useMemo, useState } from 'react'
import { useFieldArray } from 'react-hook-form';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import {  numberFormatterLocale, onCheckRequireInRowSold, parseFloatCheckValue } from '../../fnTickit';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Typography, Grid, TextField } from '@mui/material';
import { SelectItem } from 'components/Input/Select/SelectItem';
import InputNumberItem from 'components/Input/InputNumber';
import _ from "lodash";
import { DialogTicketLose } from '../DialogTicketLose';
import { ProviderSoldTicket } from '../../TicketSold/TicketSoldForm';
import { BtnAdd, BtnDelete, BtnRemark } from 'components/Button/ButtonAll';
import { I18NextNs } from 'enum/enum';

const TableSold = () => {


    //#region Hook
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    // #endregion

    const {
        isView,
        form,
        objMuseum,
        nUserType,
        option,
        setIsreRender,
        setObjTotal,
        lstTotalTicketSell,
    } = useContext(ProviderSoldTicket);

    const { control, setValue, watch, clearErrors, reset } = form;
    const { fields, append, remove } = useFieldArray({
        control,
        name: "lstSoldTicket"
    });
    const watchFieldArray = watch("lstSoldTicket");
    const watchFieldArraylstReturnTicket = watch("lstReturnTicket");
    
    const controlledFields = fields.map((field, index) => {
        return {
            ...field,
            ...watchFieldArray[index]
        };
    });

    const [isCal, setIsCal] = useState(false)
    const [isOpenRemark, setIsOpenRemark] = useState(false)
    const [rowClick, setRowClick] = useState(null)
    const [indexClick, setIndexClick] = useState(0)

    const objTotal = useMemo(() => {
        let nTotalTicket = _.sumBy(watchFieldArray, function (o: any) { return parseFloatCheckValue(o.nTotalTicket); });
        let nAmount = _.sumBy(watchFieldArray, function (o: any) { if (!o.isFree) { return parseFloatCheckValue(o.nTotalTicket) * o.nCost } else { return 0; }; });
        let nTotalRemark = _.sumBy(watchFieldArray, function (o: any) { return o.lstRemark.length; });

        let obj = {
            nTotalTicket: nTotalTicket,
            nAmount: nAmount,
            nTotalRemark: nTotalRemark,
        }
        if (setObjTotal) {
            setObjTotal(obj)
        }
        return obj;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCal, isOpenRemark, watchFieldArray, setObjTotal])


    const handleOnchange = (eValue, index, sInput) => {

        if (watchFieldArray[index].isFree && sInput === "nTotalTicket") {
            watchFieldArray[index].nTotalTicket = eValue ? parseInt(eValue) : null;
            setIsCal(isCal => !isCal)
            return;
        }

        let nTicketTypeID = watchFieldArray[index].nTicketTypeID;
        let isRequire = onCheckRequireInRowSold(watchFieldArray[index]);
        
        if (!isRequire || (!watchFieldArray[index].nStartBook && !watchFieldArray[index].nEndBook)) {
            watchFieldArray[index].nStartTicket = null;
            watchFieldArray[index].nEndTicket = null;
            watchFieldArray[index].nStartTicketID = null;
            watchFieldArray[index].nEndTicketID = null;
            watchFieldArray[index].nMaxTicket = null;
            watchFieldArray[index].nTotalTicket = null;
            watchFieldArray[index].sAmount = "";
            watchFieldArray[index].nBookSold = null;
            watchFieldArray[index].nTicketSold = null;
            watchFieldArray[index].lstRemark = [];
            watchFieldArray[index].nCountRemark = 0;
            watchFieldArray[index].lstOptionTicketStart = watchFieldArray[index].lstOptionTicket;
            watchFieldArray[index].lstOptionTicketEnd = watchFieldArray[index].lstOptionTicket;
            //Compare
            watchFieldArray[index].nBookReturn = null;
            watchFieldArray[index].nTicketReturn = null;
            clearErrors(`lstSoldTicket.${index}`)
            reset({
                ...watch(),
            });
            let isNew = watchFieldArray[index].isNew;
            let indexTypeTicket = lstTotalTicketSell.findIndex(f=>f.nTicketTypeID === nTicketTypeID)
            if(indexTypeTicket > -1)
            {
                lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck.forEach(eleTicket => {
                        //book
                        if(isNew  && eleTicket.nStatusBookId === 7)
                        {
                            eleTicket.nStatusBookId = null;
                        }
                        else if(!isNew  && eleTicket.nStatusBookId === 6)
                        {
                            eleTicket.nStatusBookId = null;
                        }
    
                        //ticket
                        if (isNew && eleTicket.nStatusTicketId === 7) {
                            eleTicket.nStatusTicketId = null;
                        }
                        else if (!isNew && eleTicket.nStatusTicketId === 6) {
                            eleTicket.nStatusTicketId = null;
                        }
                });
            }
            setIsCal(isCal => !isCal)
        }
        setValue(`lstSoldTicket.${index}.isRequire`, isRequire);

        if (!watchFieldArray[index].nStartBook && !watchFieldArray[index].nEndBook) {
            setValue(`lstSoldTicket.${index}.sAmount`, "");
            setValue(`lstSoldTicket.${index}.lstOptionBookStart`, watchFieldArray[index].lstOptionBook);
            setValue(`lstSoldTicket.${index}.lstOptionBookEnd`, watchFieldArray[index].lstOptionBook);
            setValue(`lstSoldTicket.${index}.isRequire`, false);
            OnCalReturnTicket(index);
            reset({
                ...watch(),
            });
            return;
        }
        

        if (watchFieldArray[index].isNew && sInput === "nTicketTypeID") {
            let indexOption = option.lstTicketTypeNotFree.findIndex(f => f.value === watchFieldArray[index].nTicketTypeID);
            watchFieldArray[index].sTypeTicket = indexOption > -1 ? option.lstTicketTypeNotFree[indexOption].label : "";
        }

        if (sInput === "nTotalTicket") {
            let nCost = watchFieldArray[index].nCost
            watchFieldArray[index].sAmount = (nCost * parseInt(eValue)) + "";
            watchFieldArray[index].nTotalTicket = parseInt(eValue);

            //Compare
            watchFieldArray[index].nTicketSold = parseInt(eValue);
            watchFieldArray[index].nCountRemark = watchFieldArray[index].lstRemark.length;

            let isCheckPass = (parseInt(watchFieldArray[index].nTotalTicket) + parseInt(watchFieldArray[index].nCountRemark)) === watchFieldArray[index].nMaxTicket;
            watchFieldArray[index].isPass = isCheckPass;


            setValue(`lstSoldTicket.${index}.isRequire`, false);
            setIsCal(isCal => !isCal)
            setIsreRender(value => !value)
            return;
        }

        //check cross book id
        if (watchFieldArray[index].nStartBook && watchFieldArray[index].nEndBook) {
            let nOrderNew = watchFieldArray[index].nOrderNew;
            let nTicketTypeID = watchFieldArray[index].nTicketTypeID;
            let nStartBook = watchFieldArray[index].nStartBook;
            let nEndBook = watchFieldArray[index].nEndBook;
            let lstCrossTicketType = _.filter(watchFieldArray, function (o) { return o.nOrderNew !== nOrderNew && o.nTicketTypeID === nTicketTypeID && o.nStartBook >= nStartBook && o.nEndBook <= nEndBook });
            
            if (lstCrossTicketType.length !== 0) {
                watchFieldArray[index].nStartBook = null;
                watchFieldArray[index].nEndBook = null;
                DialogFn.Warning("ไม่สามารถเลือกได้ เนื่องจากรายการดังกล่าวมีในรายการจำหน่ายแล้ว");
                reset({
                    ...watch(),
                });
                return;
            }
        }
        let changeBook = sInput === "nStartBook" || sInput === "nEndBook"
        if (watchFieldArray[index].nStartBook && watchFieldArray[index].nEndBook) {
            calculateTicketBook(index, changeBook, true);
        }
        if (watchFieldArray[index].nStartBook) {
            let lstFilter = _.filter(watchFieldArray[index].lstOptionBook, function (o) { return o.value >= watchFieldArray[index].nStartBook });
            watchFieldArray[index].lstOptionBookEnd = lstFilter;
        }

        if (watchFieldArray[index].nEndBook) {
            let lstFilter = _.filter(watchFieldArray[index].lstOptionBook, function (o) { return o.value <= watchFieldArray[index].nEndBook });
            watchFieldArray[index].lstOptionBookStart = lstFilter;
        }
        setIsCal(isCal => !isCal)
        setIsreRender(value => !value)

    }

    const calculateTicketBook = (index, isBook, isTotalInput = false) => {
        let nMuseumId = nUserType !== 1 && form.getValues("nMuseumID") ? form.getValues("nMuseumID") :  objMuseum.nMuseumID;
        let param = {
            nTicketTypeID: watchFieldArray[index].nTicketTypeID,
            nMuseum: nMuseumId,
            nStartBookID: watchFieldArray[index].nStartBook,
            nEndBookID: watchFieldArray[index].nEndBook,
            nStartTicketID: isBook ? 0 : watchFieldArray[index].nStartTicketID,
            nEndTicketID: isBook ? 0 : watchFieldArray[index].nEndTicketID,
            isCheckPrice : true,
            nSoldDate: form.getValues("dSoldTicket").valueOf()
        }

        AxiosFn.Get(`SoldTicket/GetCalculateSoldTicket`, param, (result) => {
            let objResult = result.objResult;
            if (!objResult) { 
                DialogFn.Warning(result.sMessage);
                
                return; 
            }
            //set value in list
            watchFieldArray[index].nStartTicket = objResult.nTicketMin;
            watchFieldArray[index].nEndTicket = objResult.nTicketMax;
            watchFieldArray[index].nStartTicketID = objResult.nTicketMinId;
            watchFieldArray[index].nEndTicketID = objResult.nTicketMaxId;

            watchFieldArray[index].lstOptionTicketStart = objResult.lstOptionTicketStart;
            watchFieldArray[index].lstOptionTicketEnd = objResult.lstOptionTicketEnd;
            watchFieldArray[index].nMaxTicket = objResult.nMaxTicket;
            watchFieldArray[index].nTotalTicket = objResult.nTotalTicket;
            watchFieldArray[index].sAmount = objResult.sAmount + "";
            watchFieldArray[index].lstRemark = [];
            watchFieldArray[index].nCountRemark = 0;
            //Compare
            watchFieldArray[index].nCountRemark = watchFieldArray[index].lstRemark.length;

            let isCheckPass = (watchFieldArray[index].nTotalTicket + watchFieldArray[index].nCountRemark) === watchFieldArray[index].nMaxTicket;

            watchFieldArray[index].isPass = isCheckPass;
            // Cal Ticket All
            OnCalReturnTicket(index);
            reset({
                ...watch(),
            });
            setIsCal(isCal => !isCal)
            DialogFn.UnBlockUI();
        });
    }

    const OnCalReturnTicket = (index: number) => {
        let nTicketTypeID = watchFieldArray[index].nTicketTypeID;
        let nStartBookID = watchFieldArray[index].nStartBook;
        let nEndBookID = watchFieldArray[index].nEndBook;
        let nStartTicketID = watchFieldArray[index].nStartTicketID;
        let nEndTicketID = watchFieldArray[index].nEndTicketID;
        let isNew = watchFieldArray[index].isNew;
    
        // add row but get first row set status ticket
        let indexTypeTicket = lstTotalTicketSell.findIndex(f => f.nTicketTypeID === nTicketTypeID);
        if (indexTypeTicket > -1) {
            lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck.forEach(eleTicket => {
                //book
                if (eleTicket.nBookId >= nStartBookID && eleTicket.nBookId <= nEndBookID) {
                    eleTicket.nStatusBookId = isNew ? 7 : 6;
                }
                else if (isNew && (eleTicket.nStatusBookId === 7 || eleTicket.nStatusBookId === 2)) {
                    eleTicket.nStatusBookId = null;
                }
                else if (!isNew && (eleTicket.nStatusBookId === 6 || eleTicket.nStatusBookId === 2)) {
                    eleTicket.nStatusBookId = null;
                }
    
                //ticket
                if (eleTicket.nTicketId >= nStartTicketID && eleTicket.nTicketId <= nEndTicketID) {
                    eleTicket.nStatusTicketId = isNew ? 7 : 6;
                }
                else if (isNew && eleTicket.nStatusTicketId === 7) {
                    eleTicket.nStatusTicketId = null;
                }
                else if (!isNew && eleTicket.nStatusTicketId === 6) {
                    eleTicket.nStatusTicketId = null;
                }
            });
    
            // 1 Type : 1 row
            let indexTypeReturn = watchFieldArraylstReturnTicket.findIndex(f => f.nTicketTypeID === nTicketTypeID);
            if (indexTypeReturn > -1) {
                lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck.forEach(eleTicket => {
                    //book
                    if (eleTicket.nBookId >= watchFieldArraylstReturnTicket[indexTypeReturn].nStartBookID && eleTicket.nBookId <= watchFieldArraylstReturnTicket[indexTypeReturn].nEndBookID) {
                        if (eleTicket.nStatusBookId == null) {
                            eleTicket.nStatusBookId = 5;
                        }
                    }
                    else if (eleTicket.nStatusBookId === 5) {
                        eleTicket.nStatusBookId = null;
                    }
                    //ticket
                    if (eleTicket.nTicketId >= watchFieldArraylstReturnTicket[indexTypeReturn].nStartTicketID && eleTicket.nTicketId <= watchFieldArraylstReturnTicket[indexTypeReturn].nEndTicketID) {
                        if (eleTicket.nStatusTicketId == null) {
                            eleTicket.nStatusTicketId = 5;
                        }
                    }
                    else if (eleTicket.nStatusTicketId === 5) {
                        eleTicket.nStatusTicketId = null;
                    }
                });
    
                let deepClone = lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck;
                let nReturnTicket = _.countBy(deepClone, obj => obj.nStatusTicketId === 5);
    
                let groupCountBookReturn = _.chain(deepClone)
                    .filter(obj => (obj.nStatusBookId === 5 || obj.nStatusBookId == null))
                    .groupBy('nBookId')
                    .mapValues(group => group.length)
                    .value();
    
    
                let nTotalTicket = nReturnTicket.true ?? 0;
                let nTotalBook = Object.keys(groupCountBookReturn).length ?? 0;
    
    
                watchFieldArraylstReturnTicket[indexTypeReturn].nTotalBook = nTotalBook;
                watchFieldArraylstReturnTicket[indexTypeReturn].nTotalTicket = nTotalTicket;
            }
        }
    }
    

    const handleAddSoldTicket = () => {

        let rowInvalid = watchFieldArray.findIndex(f => f.isNew === true && (!f.nTicketTypeID || !f.nStartBook || !f.nEndBook || !f.nEndTicket || !f.nTotalTicket))
        if (rowInvalid !== -1) {
            form.trigger("lstSoldTicket");
            return;
        }

        let nOrderMax = watchFieldArray.length > 0 ? Math.max(...watchFieldArray.map(itm => { return parseInt(itm.nOrder) })) + 1 : 1;
        let nOrderNewMax = watchFieldArray.length > 0 ? Math.max(...watchFieldArray.map(itm => { return parseInt(itm.nOrderNew) })) + 1 : 1;
        let objNew = {
            sID: "",
            isRequire: true,
            isFree: false,
            isNew: true,
            nTicketTypeID: null,
            nTicketGroupID: null,
            nOrder: nOrderMax,
            nOrderNew: nOrderNewMax,
            sTypeTicket: null,
            nStartBook: null,
            nEndBook: null,
            nStartTicketID: null,
            nEndTicketID: null,
            nStartTicket: null,
            nEndTicket: null,
            nMaxTicket: null,
            nTotalBook: null,
            nTotalTicket: null,
            nCost: 0,
            sAmount: "",
            lstRemark: [],
            lstOptionBook: [],
            lstOptionBookStart: [],
            lstOptionBookEnd: [],
            lstOptionTicket: [],
            lstOptionTicketStart: [],
            lstOptionTicketEnd: [],
            lstTicketTypeAll: [],
            nBookWithdraw: 0,
            nBookSold: 0,
            nBookReturn: 0,
            nTicketWithdraw: 0,
            nTicketSold: 0,
            nTicketReturn: 0,
            isPass: false,
        }
        append(objNew);
        // setIsreRender(value => !value)
    }

    const handleDeleteTicketType = (index) => {

        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.CloseSubmit();
            remove(index);
            reset({
                ...watch(),
            });
            setIsreRender(value => !value)
        });


    }

    const handleNewSelectTicket = (eValue, index) => {

        if (eValue === null) {
            //clear data
            watchFieldArray[index].nStartBook = null;
            watchFieldArray[index].nEndBook = null;
            watchFieldArray[index].nStartTicketID = null;
            watchFieldArray[index].nEndTicketID = null;
            watchFieldArray[index].nStartTicket = null;
            watchFieldArray[index].nEndTicket = null;
            watchFieldArray[index].nMaxTicket = null;
            watchFieldArray[index].nTotalBook = null;
            watchFieldArray[index].nTotalTicket = null;
            watchFieldArray[index].nCost = null;
            watchFieldArray[index].sAmount = "";
            watchFieldArray[index].lstRemark = [];
            watchFieldArray[index].lstOptionBook = [];
            watchFieldArray[index].lstOptionBookStart = [];
            watchFieldArray[index].lstOptionBookEnd = [];
            watchFieldArray[index].lstOptionTicket = [];
            watchFieldArray[index].lstOptionTicketStart = [];
            watchFieldArray[index].lstOptionTicketEnd = [];
            watchFieldArray[index].lstOptionBook = [];
            reset({
                ...watch(),
            });
            return;
        }

        let indexOption = option.lstTicketTypeNotFree.findIndex(f => f.value === watchFieldArray[index].nTicketTypeID);
        watchFieldArray[index].sTypeTicket = indexOption > -1 ? option.lstTicketTypeNotFree[indexOption].label : "";
        watchFieldArray[index].nCost = indexOption > -1 ? parseFloat(option.lstTicketTypeNotFree[indexOption].valueLabel) : "";

        let lstOptionBook = [];
        let lstUseBookId = [];

        const lstSoldTicket = watch("lstSoldTicket");
        let lstFilterType = lstSoldTicket.filter(f => f.nTicketTypeID === eValue.value);
        if (lstFilterType.length !== 0) {
            lstOptionBook = lstFilterType[0].lstOptionBook;
            lstFilterType.forEach(element => {
                let nStart = element.nStartBook;
                let nEnd = element.nEndBook;
                for (let bookId = nStart; bookId <= nEnd; bookId++) {
                    lstUseBookId.push(bookId)
                }
            });
        }
        let lstOptionBookNew = lstOptionBook.filter(item => !lstUseBookId.includes(item.value));

        watchFieldArray[index].lstOptionBook = lstOptionBookNew;
        watchFieldArray[index].lstOptionBookStart = lstOptionBookNew;
        watchFieldArray[index].lstOptionBookEnd = lstOptionBookNew;

    }


    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TableContainer id='table-receive' component={Paper}>
                    <Table sx={{ minWidth: 1200 }} >
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '60px', width: '60px' }}>ที่</TableCell>
                                <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '250px', width: '250px' }}>ประเภทบัตร</TableCell>
                                <TableCell component="th" padding='none' colSpan={2}>เล่มที่</TableCell>
                                <TableCell component="th" padding='none' colSpan={2}>เลขที่</TableCell>
                                <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '120px', width: '120px' }}>จำนวนบัตร<br />ที่จำหน่าย (ใบ)</TableCell>
                                <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '120px', width: '120px' }}>จำนวนเงิน (บาท)</TableCell>
                                <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '120px', width: '120px' }}>บัตรเสียหาย</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}>เริ่มต้น</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}>สิ้นสุด</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}>เริ่มต้น</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}>สิ้นสุด</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {
                                controlledFields.map((row, index) => {
                                    const fieldName = `lstSoldTicket.${index}`;
                                    const RowRequire = isView || row.isFree ? false : row.isRequire;

                                    return (

                                            <TableRow key={`${fieldName}.sID`}>
                                                <TableCell align="center" >
                                                    {
                                                        row.isNew ?
                                                            <BtnDelete
                                                                id={`btn-delete_${index}`}
                                                                onClick={() => handleDeleteTicketType(index)}
                                                                IsCircleWithOutText
                                                            />
                                                            :
                                                            index + 1
                                                    }
                                                </TableCell>
                                                <TableCell >
                                                    {
                                                        row.isNew ?
                                                            <SelectItem
                                                                id={`${fieldName}.nTicketTypeID`}
                                                                name={`${fieldName}.nTicketTypeID`}
                                                                defaultValue={row.nTicketTypeID}
                                                                required={true}
                                                                options={option.lstTicketTypeNotFree}
                                                                disabled={isView}
                                                                onChange={(e) => handleNewSelectTicket(e, index)}
                                                                IsShowMessageError={false}
                                                                IsPopperCustom
                                                                zIndex={1400}
                                                            />
                                                            :
                                                            <SelectItem
                                                                id={`${fieldName}.nTicketTypeID`}
                                                                name={`${fieldName}.nTicketTypeID`}
                                                                defaultValue={row.nTicketTypeID}
                                                                required={false}
                                                                options={row.lstTicketTypeAll}
                                                                disabled={true}
                                                                IsShowMessageError={false}
                                                                IsPopperCustom
                                                                zIndex={1400}
                                                            />
                                                    }
                                                </TableCell>
                                                <TableCell >
                                                    {
                                                        row.isFree ? null :
                                                            <SelectItem
                                                                id={`${fieldName}.nStartBook`}
                                                                name={`${fieldName}.nStartBook`}
                                                                defaultValue={row.nStartBook}
                                                                required={RowRequire}
                                                                options={row.lstOptionBookStart}
                                                                disabled={isView}
                                                                onChange={(e) => handleOnchange(e, index, "nStartBook")}
                                                                IsShowMessageError={false}
                                                                IsPopperCustom
                                                                zIndex={1400}
                                                            />
                                                    }
                                                </TableCell>
                                                <TableCell >
                                                    {
                                                        row.isFree ? null :
                                                            <SelectItem
                                                                id={`${fieldName}.nEndBook`}
                                                                name={`${fieldName}.nEndBook`}
                                                                defaultValue={row.nEndBook}
                                                                required={RowRequire}
                                                                options={row.lstOptionBookEnd}
                                                                disabled={isView}
                                                                onChange={(e) => handleOnchange(e, index, "nEndBook")}
                                                                IsShowMessageError={false}
                                                                IsPopperCustom
                                                                zIndex={1400}
                                                            />
                                                    }
                                                </TableCell>
                                                <TableCell >
                                                    {
                                                        row.isFree ? null :
                                                            <SelectItem
                                                                id={`${fieldName}.nStartTicketID`}
                                                                name={`${fieldName}.nStartTicketID`}
                                                                defaultValue={row.nStartTicketID}
                                                                required={RowRequire}
                                                                options={row.lstOptionTicketStart}
                                                                disabled={true}
                                                                IsShowMessageError={false}
                                                                IsPopperCustom
                                                                zIndex={1400}
                                                            />
                                                    }
                                                </TableCell>
                                                <TableCell >
                                                    {
                                                        row.isFree ? null :
                                                            <SelectItem
                                                                id={`${fieldName}.nEndTicketID`}
                                                                name={`${fieldName}.nEndTicketID`}
                                                                defaultValue={row.nEndTicketID}
                                                                required={RowRequire}
                                                                options={row.lstOptionTicketEnd}
                                                                disabled={!row.nStartTicketID || isView}
                                                                onChange={(e) => handleOnchange(e, index, "nEndTicketID")}
                                                                IsShowMessageError={false}
                                                                IsPopperCustom
                                                                zIndex={1400}
                                                            />
                                                    }
                                                </TableCell>
                                                <TableCell >
                                                    <InputNumberItem
                                                        id={`${fieldName}.nTotalTicket`}
                                                        name={`${fieldName}.nTotalTicket`}
                                                        defaultValue={row.nTotalTicket === 0 || row.nTotalTicket == null ? null : row.nTotalTicket }
                                                        required={RowRequire}
                                                        IsCanMinus={false}
                                                        disabled={isView}
                                                        min={0}
                                                        max={row.isFree ? null : row.nMaxTicket ?? null}
                                                        onChange={(e) => handleOnchange(e, index, "nTotalTicket")}
                                                        IsShowMessageError={false}
                                                    />
                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.isFree ? null :
                                                        <TextField
                                                            id={`${fieldName}.sAmount`}
                                                            name={`${fieldName}.sAmount`}
                                                            value={row.sAmount === "" || row.sAmount === "0" || row.sAmount == null ? "" : numberFormatterLocale(row.sAmount, 2)}
                                                            variant={"outlined"}
                                                            type={"text"}
                                                            size={"small"}
                                                            fullWidth={true}
                                                            disabled
                                                            inputProps={{
                                                                style: {
                                                                    textAlign: "right",
                                                                }
                                                            }}
                                                        />
                                                    }
                                                </TableCell>
                                                <TableCell align="center">
                                                    {isView && row.lstRemark.length === 0 ? null :
                                                        <div className='div-f-center'>
                                                            <Typography>{row.lstRemark.length === 0 ? null : row.lstRemark.length}</Typography>
                                                            {(RowRequire || row.nStartTicketID) ?
                                                                <BtnRemark
                                                                    id={"btn" + index}
                                                                    IsCircleWithOutText
                                                                    className='btnicon-remark'
                                                                    onClick={() => {
                                                                        setRowClick(row)
                                                                        setIndexClick(index)
                                                                        setIsOpenRemark(true)
                                                                    }}
                                                                />
                                                                : null}
                                                        </div>}
                                                </TableCell>
                                            </TableRow>

                                    )
                                })
                            }
                            {
                                controlledFields.length === 0 ?
                                    <TableRow >
                                        <TableCell align="center" colSpan={9}>ไม่พบข้อมูล</TableCell>
                                    </TableRow>
                                    :
                                    null
                            }
                            {
                                controlledFields.length === 0 ?
                                    null :
                                    <TableRow >
                                        <TableCell component="th" align="center" ></TableCell>
                                        <TableCell component="th" align="center">รวม</TableCell>
                                        <TableCell component="th" ></TableCell>
                                        <TableCell component="th" ></TableCell>
                                        <TableCell component="th" ></TableCell>
                                        <TableCell component="th" ></TableCell>
                                        <TableCell component="th" className='text-right'>{numberFormatterLocale(objTotal.nTotalTicket, 0)}</TableCell>
                                        <TableCell component="th" className='text-right'>{numberFormatterLocale(objTotal.nAmount, 2)}</TableCell>
                                        <TableCell component="th" className='text-right'>{numberFormatterLocale(objTotal.nTotalRemark, 0)}</TableCell>
                                    </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            {isView || controlledFields.length === 0 ? null :
                <Grid item xs={12}>
                    <BtnAdd id='btn-add-ticket' txt='เพิ่มรายการ' onClick={() => handleAddSoldTicket()} />
                </Grid>
            }
            <DialogTicketLose
                isOpenRemark={isOpenRemark}
                setIsOpenRemark={setIsOpenRemark}
                row={rowClick}
                controlledFields={controlledFields}
                indexClick={indexClick}
                setValue={setValue}
            />
        </Grid>
    )
}

export default TableSold

